module.exports = __webpack_public_path__ + "img/1557614071511064579.2f4b6bc0.png";